import { createSlice } from '@reduxjs/toolkit';
import { getCircularColorScheme } from 'Widgets/ColorSchemes';
export const createModelEntitiesColoringsHash = (modelNames) => {
    const colorScheme = getCircularColorScheme(modelNames.length);
    return modelNames.reduce((acc, modelName, i) => ({
        ...acc,
        [modelName]: colorScheme[i]
    }), {});
};
export const initialState = {
    modelEntitiesColoringsHash: {}
};
export const monitoringMultiModelEntitiesSlice = createSlice({
    name: 'monitoringMultiModelEntities',
    initialState,
    reducers: {
        setMultiModelEntitiesColoringsHash: (state, action) => {
            state.modelEntitiesColoringsHash = createModelEntitiesColoringsHash(action.payload);
        },
        clearMultiModelEntitiesState: () => initialState
    }
});
export const { setMultiModelEntitiesColoringsHash, clearMultiModelEntitiesState } = monitoringMultiModelEntitiesSlice.actions;
export default monitoringMultiModelEntitiesSlice.reducer;
